import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import '@static/css/reset.css'
import 'element-ui/lib/theme-chalk/base.css'
import 'babel-polyfill'
import promise from 'es6-promise'
import '@/assets/fonts/style.css'
import '@/assets/css/Favourable.styl'
import { Input, InputNumber, Option, Select, Carousel, Message, CarouselItem, Pagination, Menu, Submenu, MenuItem, MenuItemGroup, Tabs, TabPane, Progress, Steps, Step, DatePicker, Loading } from 'element-ui'
import VueLazyload from 'vue-lazyload'
import VideoPlayer from 'vue-video-player'
import VueClipboard from 'vue-clipboard2'
import VueI18n from 'vue-i18n'

import "@/api/request.js";

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.use(VueLazyload)
Vue.use(VueClipboard)
Vue.prototype.$message = Message
promise.polyfill()

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Pagination)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Progress)
Vue.use(Steps)
Vue.use(Step)
Vue.use(DatePicker)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(Option)
Vue.use(Select)
Vue.use(InputNumber)
Vue.use(Input)
Vue.use(Loading)
Vue.use(VueI18n)
// const i18n = new VueI18n({
//   locale: 'CN',    // 语言标识
//   messages : {
//     en: {
//       message: {
//         hello: 'hello world'
//       }
//     },
//     cn: {
//       message: {
//         hello: '你好、世界'
//       }
//     }
//   }
// })
const i18n = new VueI18n({
  locale: 'zh',    // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh': require('./common/lang/zh'),   // 中文语言包
    'en': require('./common/lang/en'),    // 英文语言包
    'tl': require('./common/lang/tl'),    // 泰国语言包
    'vn': require('./common/lang/vn'),    // 越南语言包
    'jp': require('./common/lang/jp'),    // 日本语言包
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: h => h(App)
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})


// WEBPACK FOOTER //
// ./src/main.js